import axios from 'axios';
import { auth } from './firebase';

// Set this to your Brain API's base URL
const BRAIN_API_URL = 'https://brain-api-service-425886683509.us-central1.run.app';

const api = axios.create({
  baseURL: BRAIN_API_URL
});

// --- THIS IS THE MAGIC ---
// This interceptor automatically adds the auth token to every request
api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// --- Genome Endpoints ---
export const saveGenome = (genomeData) => api.post('/genomes', genomeData);
export const deployGenome = (genomeId) => api.post(`/genomes/${genomeId}/deploy`);
export const getMyCreations = () => api.get('/genomes/creator');
export const getGenomeLineage = (genomeId) => api.get(`/genomes/${genomeId}/lineage`);
export const getGallery = () => api.get('/genomes/gallery');
export const publishGenome = (genomeId) => api.post(`/genomes/${genomeId}/publish`);
export const mutateGenome = (genomeId, newGenomeData) => api.post(`/genomes/${genomeId}/mutate`, newGenomeData);
export const getFeedbackForGenome = (genomeId) => api.get(`/genomes/${genomeId}/feedback`);

// --- THIS IS THE CORRECT, SINGLE FUNCTION ---
export const getGenome = (genomeId) => api.get(`/genomes/${genomeId}`);


// --- Specialist Agent Endpoints ---
export const callSpecialistAgent = (deploymentUrl, prompt) => {
  // Calls the /invoke endpoint as you specified
  return axios.post(`${deploymentUrl}/invoke`, { 
    prompt: prompt 
  });
};

export const sendFeedback = (deploymentUrl, feedbackData) => {
  // We use axios.post() directly so it doesn't try to add our
  // Brain API's auth token, since this is a public URL.
  return axios.post(`${deploymentUrl}/feedback`, feedbackData);
};

export default api;